const holidays = [
  "2025-01-01",
  "2025-01-14",
  "2025-03-14",
  "2025-03-31",
  "2025-04-18",
  "2025-05-01",
  "2025-07-06",
  "2025-08-15",
  "2025-08-27",
  "2025-10-02",
  "2025-10-21",
  "2025-11-01",
  "2025-12-25",
];

export const DisableDates = [];
export const publicHolidays = holidays;
